import { useContext } from 'react';
import { ACTIONS } from '../../../../../constants';
import { AppContext } from '../../../../context';
import { ReportItem } from '../MenuItem';
import { getActionService } from '../../../../../utils/getActionService';
import { DownloadReportsModel, EmployeeNodeModel } from '../../../../../models';
import { getEmployeesIds } from '../../../../../utils';
import { handleDownloadReport } from '../../../../../utils/handleDownloadReport';
import { Extension } from 'typescript';
import { ReportItemWithFormats } from '../ReportItemWithFormats';

interface Props {
    startDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
    endDateScheduling: string;
}

export const PreliquidationsMenuGroup: React.FC<Props> = ({
    startDateScheduling,
    selectedEmployees,
    endDateScheduling,
}) => {
    const { langResources, downloadReport, userInfo } = useContext(AppContext);

    /**
     * Descarga el reporte de Liquidacion de Bonificaciones
     */
    const handlerSaveReportBonusLiquidations = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte de Liquidación de Bonificaciones',
            '/jerusalem/api/v2.0.0/reports/bonus-liquidations',
            downloadReport
        );
    };

     /**
     * Descarga el reporte de Liquidacion de tipos de horas Agrupado por Empleado
     */
    const handlerSaveReportLiquidationByTypeHoursByEmployeeReport = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte de labor detallado por empleado',
            '/jerusalem/api/v2.0.0/reports/liquidation-by-type-of-hours-by-employee',
            downloadReport
        );
    };

    /**
     * Descarga el reporte de Liquidacion de Bonificaciones Agrupado por Empleado
     */
    // Handler único que inyecta la extensión en la URL y el Provider
    const handlerSaveReportBonusLiquidationsGroupedByEmployee= (extension: 'pdf' | 'xlsx') => {
    handleDownloadReport(
        startDateScheduling,
        endDateScheduling,
        getEmployeesIds(selectedEmployees),
        langResources['reports.message.alert'],
        'Reporte de Liquidación de Bonificaciones por Empleado',
        `/jerusalem/api/v2.0.0/reports/bonus-liquidations-grouped-by-employee/${extension}`, 
        downloadReport,
        true,
        extension
    );
};

    /**
     * Descarga el reporte de Labor desglosado por empleado (columnas de empleado en cada fila)
     */
    const handlerSaveReportLiquidationByTypeHoursFlatByEmployee = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte de labor desglosado por empleado',
            '/jerusalem/api/v2.0.0/reports/liquidation-by-type-hours-flat-by-employee',
            downloadReport
        );
    };

    const menuItems = [
        {
            action: ACTIONS['reports']['BonusLiquidationsReport'],
            label: 'Reporte de Liquidación de bonificaciones',
            handler: handlerSaveReportBonusLiquidations,
        },
        {
            action: ACTIONS['reports']['LiquidationByTypeHoursByEmployeeReport'],
            label: 'Labor detallado por empleado',
            handler: handlerSaveReportLiquidationByTypeHoursByEmployeeReport,
        },
        {
            action: ACTIONS['reports']['LiquidationByTypeHoursFlatByEmployeeReport'],
            label: 'Labor desglosado por empleado',
            handler: handlerSaveReportLiquidationByTypeHoursFlatByEmployee,
        }
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>Liquidación</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

           <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-3'>
                    {menuItems.map(
                        ({ action, label, handler }, index) =>
                            getActionService(userInfo.actions, action) && (
                                <ReportItem
                                    key={index}
                                    label={label}
                                    handler={handler}
                                />
                            )
                    )}
                </ul>

                <ul className='nav nav-sm flex-column px-3'>
                    {getActionService(userInfo.actions, ACTIONS['reports']['LiquidationByTypeHoursByEmployeeReport']) && (
                        <ReportItemWithFormats 
                            label='Liquidación de Bonificaciones por Empleado'
                            onDownload={handlerSaveReportBonusLiquidationsGroupedByEmployee}
                        />
                    )}
                </ul>
            </div>                 
        </li>
    );
};
